export default Object.freeze({
  PROPERTY_COMPARABLES_SALES_TENANT_LIST: 6,
  PROPERTY_COMPARABLES_LEASE_BREAK_OPTIONS: 7,
  PROPERTY_COMPARABLES_SALES_AGENT_INFORMATION: 11,
  PROPERTY_COMPARABLES_LEASE_AGENT_INFORMATION: 16,

  RESEARCH_LEASE_BASE_RENT: 17,

  PERSONAS_PERSONAS_LIST: 100,
  PERSONAS_PERSONAS_DOCUMENTS: 101,
  PROPERTY_PROPERTY_REPORTS_CERTIFICATION: 102,
  PROPERTY_PROPERTY_DETAILS_TAB: 103,
  PROPERTY_PROPERTY_SCOPE_TAB: 104,
  DASHBOARD_DASHBOARD_MY_MANDATES_ALL_MANDATES: 105,
  DASHBOARD_DASHBOARD_PROPERTIES_EDI_CREATE_MANDATE: 106,
  DASHBOARD_DASHBOARD_PROPERTIES_MAP_SCREEN_PROPERTY_INFO: 107,
  DASHBOARD_DASHBOARD_PROPERTIES_INSTRUCTING_PARTY: 108,
  DASHBOARD_DASHBOARD_PROPERTIES_CONTACT_SEARCH: 109,
  DASHBOARD_DASHBOARD_RESEARCH: 110,

  ROLES: 111,
  PROFILES: 112,
  PROFILES_ASSOCIATED_ROLES: 113,
  USERS: 114,
  USERS_ASSOCIATED_PROFILES: 115,

  PROPERTY_PROPERTY_DOCUMENTS: 200,
  PROPERTY_PROPERTY_REPORTS_REPORT_HISTORY: 201,
  COMPS_COMPS_DOCUMENTS: 300,
  COMPS_MULTIFAMILY_TABLE_CONFIG: 1000,

  COMPARABLES_AUDIT_LOG: 1004,
});
